import './Rewards.css';

const cards = [
  { emoji: '🦁', name: 'Leo', rarity: 'Épique', unlocked: true },
  { emoji: '🐉', name: 'Drago', rarity: 'Légendaire', unlocked: true },
  { emoji: '🦋', name: 'Luna', rarity: 'Rare', unlocked: true },
  { emoji: '⚔️', name: 'Warrior', rarity: 'Héroïque', unlocked: false },
  { emoji: '🌟', name: '???', rarity: '???', unlocked: false },
];

const mascots = [
  { emoji: '🐰', name: 'Evo', level: 3, xp: 680, maxXp: 1000 },
  { emoji: '🦊', name: 'Riko', level: 1, xp: 120, maxXp: 500 },
  { emoji: '🐻', name: 'Kuro', level: 2, xp: 340, maxXp: 750 },
];

export default function Rewards() {
  return (
    <section className="rewards" id="recompenses">
      <div className="rewards__bg" />

      <div className="container">
        <div className="rewards__header">
          <div className="section-label">🏆 Récompenses</div>
          <h2 className="section-title">Des récompenses qui racontent une histoire</h2>
          <p className="section-subtitle">
            Pas de cadeaux matériels, pas de "pay to win". Des collections à débloquer et des mascottes à faire évoluer — la progression devient visible et motivante.
          </p>
        </div>

        <div className="rewards__bento">

          {/* Block 1 — Collections */}
          <div className="rewards__block" style={{ '--block-color': '#F59E0B' }}>
            <div className="rewards__block-body">
              <div className="rewards__block-top">
                <div className="rewards__block-icon-wrap">
                  <span className="rewards__block-icon">🎴</span>
                </div>
                <span className="rewards__block-badge">COLLECTIONS</span>
              </div>
              <h3 className="rewards__block-title">Collections de cartes</h3>
              <p className="rewards__block-desc">10 cartes par collection · Déblocage progressif. Quand l'enfant franchit un palier, il découvre sa carte — un instant de magie de 10-15 secondes.</p>

              {/* Mini cards preview */}
              <div className="rewards__cards-row">
                {cards.map((card, i) => (
                  <div key={i} className={`rewards__mini-card${!card.unlocked ? ' rewards__mini-card--locked' : ''}`}>
                    <span className="rewards__mini-card-emoji">{card.unlocked ? card.emoji : '🔒'}</span>
                    <small className="rewards__mini-card-name">{card.name}</small>
                  </div>
                ))}
              </div>

              <ul className="rewards__tags">
                <li>🎴 Déblocage progressif</li>
                <li>✨ Moment de découverte</li>
                <li>🃏 Raretés variées</li>
              </ul>
            </div>
          </div>

          {/* Block 2 — Mascottes */}
          <div className="rewards__block" style={{ '--block-color': '#9B59F5' }}>
            <div className="rewards__block-body">
              <div className="rewards__block-top">
                <div className="rewards__block-icon-wrap">
                  <span className="rewards__block-icon">🐾</span>
                </div>
                <span className="rewards__block-badge">MASCOTTES</span>
              </div>
              <h3 className="rewards__block-title">Mascottes évolutives</h3>
              <p className="rewards__block-desc">Elles grandissent avec l'enfant. Choix libre, progression visible — l'enfant décide de qui faire évoluer.</p>

              {/* Mascots list */}
              <div className="rewards__mascots-list">
                {mascots.map((m, i) => (
                  <div key={i} className="rewards__mascot-row">
                    <span className="rewards__mascot-emoji">{m.emoji}</span>
                    <div className="rewards__mascot-info">
                      <div className="rewards__mascot-top">
                        <span className="rewards__mascot-name">{m.name}</span>
                        <span className="rewards__mascot-level">Niv. {m.level}</span>
                      </div>
                      <div className="rewards__mascot-bar">
                        <div className="rewards__mascot-fill" style={{ width: `${(m.xp / m.maxXp) * 100}%` }} />
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              <ul className="rewards__tags">
                <li>🐾 Choix libre</li>
                <li>📈 Progression visible</li>
                <li>🌟 Évolutions multiples</li>
              </ul>
            </div>
          </div>

          {/* Block 3 — Le moment du choix (full-width) */}
          <div className="rewards__block rewards__block--choice" style={{ '--block-color': '#FF6B4A' }}>
            <div className="rewards__choice-lead">
              <div className="rewards__block-icon-wrap">
                <span className="rewards__block-icon">🎉</span>
              </div>
              <div className="rewards__choice-text">
                <span className="rewards__block-badge">LE MOMENT DU CHOIX</span>
                <h3 className="rewards__block-title">C'est lui qui décide</h3>
                <p className="rewards__block-desc">Quand l'enfant franchit un palier d'XP, il choisit librement : débloquer une nouvelle carte ou faire évoluer sa mascotte. Ce moment de choix lui appartient — et c'est ce qui le rend si précieux.</p>
              </div>
            </div>
            <div className="rewards__choice-buttons">
              <div className="rewards__choice-btn">
                <span className="rewards__choice-btn-icon">🎴</span>
                <span className="rewards__choice-btn-label">Nouvelle carte</span>
              </div>
              <div className="rewards__choice-or">ou</div>
              <div className="rewards__choice-btn">
                <span className="rewards__choice-btn-icon">🐾</span>
                <span className="rewards__choice-btn-label">Faire évoluer<br />ma mascotte</span>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}
